import React, { useCallback } from 'react'
import clsx from 'clsx'
import { useDropzone } from 'react-dropzone'
import Icon from '../Icon/Icon'

export const FileInput = ({
  otherClasses,
  heading,
  setState,
  inputName,
  fileNameToDisplay,
  warning,
}) => {
  const onDrop = useCallback((acceptedFiles) => {
    setState((prev) => ({
      ...prev,
      [inputName]: acceptedFiles[0],
    }))
    // setFile(acceptedFiles[0])
  }, [])
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    noClick: true,
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'application/pdf': [],
      'application/vnd.ms-excel': [],
    },
  })

  const fileInputClasses = clsx(
    otherClasses,
    ' cursor-pointer mb-6 w-full py-10 px-3 rounded-[4px] border-[1px] border-[#B2B2B2] border-dashed',
    warning ? 'border-[#ff4444]' : 'border-[#B2B2B2]'
  )

  return (
    <div className={fileInputClasses}>
      <label className="flex flex-col items-center cursor-pointer">
        <div
          {...getRootProps()}
          className="flex flex-col items-center gap-3 cursor-pointer"
        >
          {warning ? (
            <Icon icon="add-image-icon-red" iconHeight={32} iconWidth={32} />
          ) : (
            <Icon icon="add-image-icon" iconHeight={32} iconWidth={32} />
          )}

          <div className="flex flex-col items-center gap-1 cursor-pointer">
            <p
              className={clsx(
                'font-Mulish text-sm leading-5 font-bold ',
                warning ? 'text-[#ff4444]' : 'text-[#1A1A1A]'
              )}
            >
              {heading}
            </p>
            {fileNameToDisplay ? (
              <p className="text-sm leading-5 text-gray-400 font-Mulish font-normal ">
                {fileNameToDisplay}
              </p>
            ) : (
              <p
                className={clsx(
                  'text-sm leading-5  font-Mulish font-normal ',
                  warning ? 'text-[#ff4444]' : 'text-gray-400'
                )}
              >
                Drag & drop an image or{' '}
                <span
                  className={clsx(
                    ' cursor-pointer hover:no-underline text-sm leading-5 underline  font-Mulish font-normal mr-1',
                    warning ? 'text-[#ff4444]' : 'text-[#006CEA]'
                  )}
                >
                  upload
                </span>
                from your files
              </p>
            )}
          </div>
        </div>
        <input
          required={true}
          id="file"
          name={inputName}
          type="file"
          hidden
          {...getInputProps()}
        />
      </label>
    </div>
  )
}

export default FileInput
